import { render, staticRenderFns } from "./Finger.vue?vue&type=template&id=b0a5c658"
import script from "./Finger.vue?vue&type=script&lang=ts"
export * from "./Finger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports